var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5312 23.9531C28.9875 23.9531 28.5469 23.5125 28.5469 22.9688V4.26562H13.4531V22.9688C13.4531 23.5125 13.0125 23.9531 12.4688 23.9531C11.925 23.9531 11.4844 23.5125 11.4844 22.9688V3.28125C11.4844 2.73747 11.925 2.29688 12.4688 2.29688H29.5312C30.075 2.29688 30.5156 2.73747 30.5156 3.28125V22.9688C30.5156 23.5125 30.075 23.9531 29.5312 23.9531Z",
    fill: "url(#paint0_linear_82_6093)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28125 25.9218C2.73747 25.9218 2.29688 25.4812 2.29688 24.9374V15.6342C2.29688 15.2142 2.56348 14.8405 2.96049 14.7037L12.148 11.5381C12.6636 11.3603 13.2224 11.6343 13.3993 12.1479C13.5765 12.6619 13.3035 13.2223 12.7895 13.3992L4.26562 16.3363V24.9374C4.26562 25.4812 3.82503 25.9218 3.28125 25.9218Z",
    fill: "url(#paint1_linear_82_6093)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7187 25.9219C38.1749 25.9219 37.7343 25.4813 37.7343 24.9376V16.3364L29.2104 13.3993C28.6965 13.2225 28.4235 12.662 28.6007 12.148C28.7775 11.6344 29.3367 11.3601 29.852 11.5383L39.0395 14.7038C39.4365 14.8407 39.7031 15.2143 39.7031 15.6344V24.9375C39.7031 25.4813 39.2625 25.9219 38.7187 25.9219Z",
    fill: "url(#paint2_linear_82_6093)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 14.7656C15.8625 14.7656 15.4219 14.325 15.4219 13.7812V11.8125C15.4219 11.2687 15.8625 10.8281 16.4062 10.8281C16.95 10.8281 17.3906 11.2687 17.3906 11.8125V13.7812C17.3906 14.325 16.95 14.7656 16.4062 14.7656Z",
    fill: "url(#paint3_linear_82_6093)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 21.3281C7.33122 21.3281 6.89062 20.8875 6.89062 20.3438V18.375C6.89062 17.8312 7.33122 17.3906 7.875 17.3906C8.41878 17.3906 8.85938 17.8312 8.85938 18.375V20.3438C8.85938 20.8875 8.41878 21.3281 7.875 21.3281Z",
    fill: "url(#paint4_linear_82_6093)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 21.3281C33.5812 21.3281 33.1406 20.8875 33.1406 20.3438V18.375C33.1406 17.8312 33.5812 17.3906 34.125 17.3906C34.6688 17.3906 35.1094 17.8312 35.1094 18.375V20.3438C35.1094 20.8875 34.6688 21.3281 34.125 21.3281Z",
    fill: "url(#paint5_linear_82_6093)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.7656C20.4562 14.7656 20.0156 14.325 20.0156 13.7812V11.8125C20.0156 11.2687 20.4562 10.8281 21 10.8281C21.5438 10.8281 21.9844 11.2687 21.9844 11.8125V13.7812C21.9844 14.325 21.5438 14.7656 21 14.7656Z",
    fill: "url(#paint6_linear_82_6093)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5938 14.7656C25.05 14.7656 24.6094 14.325 24.6094 13.7812V11.8125C24.6094 11.2687 25.05 10.8281 25.5938 10.8281C26.1375 10.8281 26.5781 11.2687 26.5781 11.8125V13.7812C26.5781 14.325 26.1375 14.7656 25.5938 14.7656Z",
    fill: "url(#paint7_linear_82_6093)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 9.51562C15.8625 9.51562 15.4219 9.07503 15.4219 8.53125V6.5625C15.4219 6.01872 15.8625 5.57812 16.4062 5.57812C16.95 5.57812 17.3906 6.01872 17.3906 6.5625V8.53125C17.3906 9.07503 16.95 9.51562 16.4062 9.51562Z",
    fill: "url(#paint8_linear_82_6093)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.51562C20.4562 9.51562 20.0156 9.07503 20.0156 8.53125V6.5625C20.0156 6.01872 20.4562 5.57812 21 5.57812C21.5438 5.57812 21.9844 6.01872 21.9844 6.5625V8.53125C21.9844 9.07503 21.5438 9.51562 21 9.51562Z",
    fill: "url(#paint9_linear_82_6093)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5938 9.51562C25.05 9.51562 24.6094 9.07503 24.6094 8.53125V6.5625C24.6094 6.01872 25.05 5.57812 25.5938 5.57812C26.1375 5.57812 26.5781 6.01872 26.5781 6.5625V8.53125C26.5781 9.07503 26.1375 9.51562 25.5938 9.51562Z",
    fill: "url(#paint10_linear_82_6093)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 20.0156C15.8625 20.0156 15.4219 19.575 15.4219 19.0312V17.0625C15.4219 16.5187 15.8625 16.0781 16.4062 16.0781C16.95 16.0781 17.3906 16.5187 17.3906 17.0625V19.0312C17.3906 19.575 16.95 20.0156 16.4062 20.0156Z",
    fill: "url(#paint11_linear_82_6093)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.0156C20.4562 20.0156 20.0156 19.575 20.0156 19.0312V17.0625C20.0156 16.5187 20.4562 16.0781 21 16.0781C21.5438 16.0781 21.9844 16.5187 21.9844 17.0625V19.0312C21.9844 19.575 21.5438 20.0156 21 20.0156Z",
    fill: "url(#paint12_linear_82_6093)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5938 20.0156C25.05 20.0156 24.6094 19.575 24.6094 19.0312V17.0625C24.6094 16.5187 25.05 16.0781 25.5938 16.0781C26.1375 16.0781 26.5781 16.5187 26.5781 17.0625V19.0312C26.5781 19.575 26.1375 20.0156 25.5938 20.0156Z",
    fill: "url(#paint13_linear_82_6093)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85934 34.1249C6.35931 34.1249 4.3252 32.0908 4.3252 29.5908C4.3252 27.0908 6.35931 25.0566 8.85934 25.0566C11.3594 25.0566 13.3935 27.0908 13.3935 29.5908C13.3935 32.0908 11.3594 34.1249 8.85934 34.1249ZM8.85934 27.0254C7.44463 27.0254 6.29395 28.1761 6.29395 29.5908C6.29395 31.0055 7.44463 32.1562 8.85934 32.1562C10.2741 32.1562 11.4247 31.0055 11.4247 29.5908C11.4247 28.1761 10.2741 27.0254 8.85934 27.0254Z",
    fill: "url(#paint14_linear_82_6093)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 39.7031H3.28125C2.73747 39.7031 2.29688 39.2625 2.29688 38.7188C2.29688 35.1001 5.24071 32.1562 8.85938 32.1562C11.559 32.1562 14.02 33.8478 14.9829 36.3658C15.1771 36.8734 14.923 37.4425 14.4151 37.6366C13.9065 37.8311 13.3387 37.5767 13.1442 37.0688C12.4707 35.308 10.7487 34.125 8.85938 34.125C6.66408 34.125 4.8235 35.6727 4.37169 37.7344H9.84375C10.3875 37.7344 10.8281 38.175 10.8281 38.7188C10.8281 39.2625 10.3875 39.7031 9.84375 39.7031Z",
    fill: "url(#paint15_linear_82_6093)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1406 34.1249C30.6406 34.1249 28.6064 32.0908 28.6064 29.5908C28.6064 27.0908 30.6406 25.0566 33.1406 25.0566C35.6406 25.0566 37.6747 27.0908 37.6747 29.5908C37.6747 32.0908 35.6406 34.1249 33.1406 34.1249ZM33.1406 27.0254C31.7259 27.0254 30.5752 28.1761 30.5752 29.5908C30.5752 31.0055 31.7259 32.1562 33.1406 32.1562C34.5553 32.1562 35.706 31.0055 35.706 29.5908C35.706 28.1761 34.5553 27.0254 33.1406 27.0254Z",
    fill: "url(#paint16_linear_82_6093)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7187 39.7031H32.1562C31.6125 39.7031 31.1719 39.2625 31.1719 38.7188C31.1719 38.175 31.6125 37.7344 32.1562 37.7344H37.6283C37.1765 35.6727 35.3359 34.125 33.1406 34.125C31.2513 34.125 29.5293 35.308 28.8558 37.0688C28.6619 37.5767 28.0944 37.8308 27.5849 37.6366C27.077 37.4425 26.8229 36.8734 27.0171 36.3658C27.98 33.8478 30.441 32.1562 33.1406 32.1562C36.7593 32.1562 39.7031 35.1001 39.7031 38.7188C39.7031 39.2625 39.2625 39.7031 38.7187 39.7031Z",
    fill: "url(#paint17_linear_82_6093)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 15.0348C7.33122 15.0348 6.89062 14.5942 6.89062 14.0504V9.18749C6.89062 8.79367 7.12518 8.43799 7.48727 8.28258L12.0804 6.31383C12.579 6.10106 13.159 6.33146 13.373 6.83101C13.5871 7.33057 13.3557 7.90928 12.8558 8.12365L8.85938 9.83669V14.0504C8.85938 14.5942 8.41878 15.0348 7.875 15.0348Z",
    fill: "url(#paint18_linear_82_6093)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1249 15.0348C33.5812 15.0348 33.1406 14.5942 33.1406 14.0504V9.83669L29.1441 8.12365C28.6442 7.90928 28.4129 7.33057 28.6269 6.83101C28.8419 6.33145 29.4222 6.10106 29.9196 6.31383L34.5127 8.28258C34.8748 8.43799 35.1093 8.79367 35.1093 9.18749V14.0504C35.1093 14.5942 34.6687 15.0348 34.1249 15.0348Z",
    fill: "url(#paint19_linear_82_6093)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21 32.4844C17.9241 32.4844 15.4219 29.9821 15.4219 26.9062C15.4219 23.8304 17.9241 21.3281 21 21.3281C24.0759 21.3281 26.5781 23.8304 26.5781 26.9062C26.5781 29.9821 24.0759 32.4844 21 32.4844ZM21 23.2969C19.0098 23.2969 17.3906 24.916 17.3906 26.9062C17.3906 28.8965 19.0098 30.5156 21 30.5156C22.9902 30.5156 24.6094 28.8965 24.6094 26.9062C24.6094 24.916 22.9902 23.2969 21 23.2969Z",
    fill: "url(#paint20_linear_82_6093)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2188 39.7031H13.7812C13.2375 39.7031 12.7969 39.2625 12.7969 38.7188C12.7969 34.1955 16.4767 30.5156 21 30.5156C25.5233 30.5156 29.2031 34.1955 29.2031 38.7188C29.2031 39.2625 28.7625 39.7031 28.2188 39.7031ZM14.8432 37.7344H27.1568C26.6835 34.7627 24.1028 32.4844 21 32.4844C17.8972 32.4844 15.3165 34.7627 14.8432 37.7344Z",
    fill: "url(#paint21_linear_82_6093)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_82_6093",
    x1: 20.4912,
    y1: -21.3224,
    x2: 35.7989,
    y2: 13.1343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_82_6093",
    x1: 7.57685,
    y1: -4.26273,
    x2: 18.6478,
    y2: 17.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_82_6093",
    x1: 33.8266,
    y1: -4.26287,
    x2: 44.8977,
    y2: 17.6494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_82_6093",
    x1: 16.3536,
    y1: 6.53372,
    x2: 19.9923,
    y2: 11.1939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_82_6093",
    x1: 7.82237,
    y1: 13.0962,
    x2: 11.4611,
    y2: 17.7564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_82_6093",
    x1: 34.0724,
    y1: 13.0962,
    x2: 37.7111,
    y2: 17.7564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_82_6093",
    x1: 20.9474,
    y1: 6.53372,
    x2: 24.5861,
    y2: 11.1939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_82_6093",
    x1: 25.5411,
    y1: 6.53372,
    x2: 29.1798,
    y2: 11.1939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_82_6093",
    x1: 16.3536,
    y1: 1.28372,
    x2: 19.9923,
    y2: 5.94386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_82_6093",
    x1: 20.9474,
    y1: 1.28372,
    x2: 24.5861,
    y2: 5.94386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_82_6093",
    x1: 25.5411,
    y1: 1.28372,
    x2: 29.1798,
    y2: 5.94386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_82_6093",
    x1: 16.3536,
    y1: 11.7837,
    x2: 19.9923,
    y2: 16.4439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_82_6093",
    x1: 20.9474,
    y1: 11.7837,
    x2: 24.5861,
    y2: 16.4439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_82_6093",
    x1: 25.5411,
    y1: 11.7837,
    x2: 29.1798,
    y2: 16.4439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_82_6093",
    x1: 8.61692,
    y1: 15.1664,
    x2: 14.4696,
    y2: 30.1574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_82_6093",
    x1: 8.3316,
    y1: 23.9253,
    x2: 11.4854,
    y2: 37.5741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_82_6093",
    x1: 32.8982,
    y1: 15.1664,
    x2: 38.7508,
    y2: 30.1574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_82_6093",
    x1: 32.9866,
    y1: 23.9253,
    x2: 36.1404,
    y2: 37.5741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_82_6093",
    x1: 9.99629,
    y1: -3.36322,
    x2: 16.8854,
    y2: 9.79512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_82_6093",
    x1: 31.6528,
    y1: -3.36322,
    x2: 38.5419,
    y2: 9.79512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_82_6093",
    x1: 20.7018,
    y1: 9.16064,
    x2: 27.9019,
    y2: 27.6033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_82_6093",
    x1: 20.5614,
    y1: 20.4953,
    x2: 24.2135,
    y2: 37.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D180DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSme);
export default __webpack_public_path__ + "static/media/SME.cd6f927b0f31c39da129a5a5d6e670fe.svg";
export { ForwardRef as ReactComponent };